import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Stat {
  id: string;
  value: string;
  label: string;
  icon: string;
  color: string;
}

const ImpactStats: React.FC = () => {
  const stats: Stat[] = [
    {
      id: 'lives',
      value: '15,000+',
      label: 'Lives Touched',
      icon: 'UserGroupIcon',
      color: 'text-primary',
    },
    {
      id: 'volunteers',
      value: '500+',
      label: 'Active Volunteers',
      icon: 'HandRaisedIcon',
      color: 'text-secondary',
    },
    {
      id: 'services',
      value: '25,000+',
      label: 'Services Provided',
      icon: 'HeartIcon',
      color: 'text-accent',
    },
    {
      id: 'partners',
      value: '50+',
      label: 'Partner Organizations',
      icon: 'BuildingOfficeIcon',
      color: 'text-supporting',
    },
  ];

  return (
    <div className="bg-gradient-to-r from-primary/5 via-secondary/5 to-accent/5 rounded-xl p-6 lg:p-8">
      <div className="text-center mb-8">
        <h3 className="text-2xl lg:text-3xl font-heading font-bold text-foreground mb-2">
          Our Collective Impact
        </h3>
        <p className="text-muted-foreground">
          Together, we're creating meaningful change in our community
        </p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat) => (
          <div
            key={stat.id}
            className="bg-card rounded-xl p-6 text-center shadow-subtle hover:shadow-elevated transition-all duration-300 group"
          >
            <div className="w-12 h-12 mx-auto mb-4 bg-muted rounded-lg flex items-center justify-center group-hover:scale-105 transition-transform duration-300">
              <Icon name={stat.icon as any} size={24} className={stat.color} variant="solid" />
            </div>
            <div className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-2">
              {stat.value}
            </div>
            <div className="text-sm text-muted-foreground font-medium">
              {stat.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImpactStats;